<div class="main-content container-white">
  <div class="container-fluid">
    <h1>Редактировать шаблон</h1>

    <div class="row">
      <div class="col-10">
        <form [formGroup]="form">
          <div class="form-panel">
            <formly-form [model]="model_header" [fields]="fields" [options]="options" [form]="form"></formly-form>
          </div>
          
          <!-- Кнопки действий внутри формы -->
          <div class="action-buttons">
            <button mat-raised-button color="primary" (click)="save()" type="button">Сохранить</button>
            <button mat-raised-button color="warn" (click)="exit()" style="margin-left:10px;" type="button">Отмена</button>
            <button mat-raised-button type="button" class="btn btn-info" (click)="openTemplatePreview()" style="margin-left:10px;" [disabled]="!Entity || !Entity.ID || Entity.ID === 0">Предпросмотр</button>
          </div>
        </form>
      </div>
      <div class="col-2">
        <div class="image-block">
          <div class="main-image-container" (click)="show_full()">
            <img id="preview" [src]="img_path" alt="Главное изображение" />
            <div class="overlay-buttons" (click)="$event.stopPropagation()">
              <button mat-mini-fab color="primary" class="edit-image-btn" (click)="mainImageInput.click()">
                <mat-icon>edit</mat-icon>
              </button>
              <button mat-mini-fab color="warn" class="delete-image-btn" (click)="removeMainImage()" [disabled]="!Entity || !Entity.URLPicture">
                <mat-icon>delete</mat-icon>
              </button>
            </div>
          </div>
          <input type="file" #mainImageInput style="display:none" accept="image/*" (change)="onMainImageSelected($event)" />
        </div>
      </div>
    </div>

    <!-- Внешние вкладки: Знания / Управление файлами -->
    <mat-tab-group class="outer-tabs" mat-stretch-tabs="false" mat-align-tabs="start">
      <mat-tab label="Знания">
        <!-- Внутренние вкладки: две строки, как в создании сущности -->
        <mat-tab-group class="inner-tabs" mat-stretch-tabs="false" mat-align-tabs="start">
          <mat-tab label="Тактико-технические характеристики">
            <div class="edit-section">
              <json-editor
                #openEditor
                [options]="editorOptionsOpen"
                [data]="initialDataOpen"
                (change)="showJsonOpen($event)">
              </json-editor>
            </div>
          </mat-tab>
          <mat-tab label="Особенности реализации">
            <div class="edit-section">
              <json-editor
                #privateEditor
                [options]="editorOptionsPrivate"
                [data]="initialDataPrivate"
                (change)="showJsonPrivate($event)">
              </json-editor>
            </div>
          </mat-tab>
        </mat-tab-group>
      </mat-tab>

      <mat-tab label="Управление файлами">
        <div class="file-management-section">
          <h2>Управление файлами</h2>
          <div class="upload-section">
            <button mat-raised-button color="primary" (click)="fileInput.click()">
              <mat-icon>attach_file</mat-icon>
              Выберите файл
            </button>
            <span *ngIf="selectedUploadFile">{{ selectedUploadFile.name }}</span>
            <mat-form-field class="upload-field" appearance="fill">
              <mat-label>Отображаемое имя</mat-label>
              <input matInput [(ngModel)]="selectedUploadFileTitle" placeholder="Введите имя файла" name="selectedUploadFileTitle" />
            </mat-form-field>
            <button mat-raised-button color="primary" (click)="uploadSelectedFile()" [disabled]="!selectedUploadFile">
              <mat-icon>cloud_upload</mat-icon>
              Загрузить
            </button>
            <input type="file" #fileInput style="display:none" (change)="onUploadFileSelected($event)" />
          </div>

          <table mat-table [dataSource]="filesDataSource" class="mat-elevation-z8">
            <ng-container matColumnDef="ShortTitle">
              <th mat-header-cell *matHeaderCellDef>Имя файла</th>
              <td mat-cell *matCellDef="let file">
                <mat-icon color="accent">insert_drive_file</mat-icon>
                {{ file.ShortTitle }}
              </td>
            </ng-container>
            <ng-container matColumnDef="actions">
              <th mat-header-cell *matHeaderCellDef>Действия</th>
              <td mat-cell *matCellDef="let file">
                <button mat-icon-button color="primary" (click)="downloadFile(file)">
                  <mat-icon>cloud_download</mat-icon>
                </button>
                <button mat-icon-button color="warn" (click)="deleteFile(file)">
                  <mat-icon>delete</mat-icon>
                </button>
              </td>
            </ng-container>
            <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
            <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
          </table>
          <mat-paginator [pageSizeOptions]="[5,10,25]" showFirstLastButtons></mat-paginator>
          <div *ngIf="filesDataSource.data?.length === 0" class="no-files">
            <p>Файлы отсутствуют.</p>
          </div>
        </div>
      </mat-tab>
    </mat-tab-group>
  </div>
</div>